import { Component, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { TitleLineConfigurations } from '../title/title.configurations';
import { CommonModule } from '@angular/common';
import { TitleComponent } from '../title/title.component';

@Component({
  selector: 'kla-outgrow',
  templateUrl: './outgrow.component.html',
  styleUrls: ['./outgrow.component.scss'],
  standalone: true,
  imports: [ CommonModule, TitleComponent ]
})
export class OutgrowComponent implements OnInit, AfterViewInit {

  @Input() config: any;

  @Input()
  public lineConfig: TitleLineConfigurations;

  @ViewChild('template') template;

  get title() {
    return this.config.configurations.title;
  }

  get header() {
    return this.config.configurations.header;
  }

  get embedCode() {
    return this.config.configurations.embedCode;
  }

  get description () {
    return this.config.configurations.description;
  }

  get name () {
    return this.config.name;
  }

  get imagePosition() {
    if(this.config.configurations.imagePosition) {
      return this.config.configurations.imagePosition;
    } else {
      return 'left';
    }
  }

  titleConfigurations: any = {
    description: '',
    header: '',
    imageHeight: '',
    imageWidth: '',
    title: ''
  }

  constructor() { }

  ngOnInit(): void {
    setTimeout(() => {
      this.titleConfigurations = {
        description: this.description,
        header: this.header,
        title: this.title,
      }
    }, 200)
  }

  private getSrcFromScript(string) {
    const fullSrc = string?.split('src=')[1];
    let src: string;
    if (fullSrc) {
      src = fullSrc.split(/[ >]/)[0];
      src = src.substring(1, src.length - 1);
    }
    return src;
  }

  ngAfterViewInit(): void {
    const re = /<script\b[^>]*>[\s\S]*?<\/script\b[^>]*>/g
    const scripts = this.embedCode.match(re)

    let srcScript = scripts?.find(script => script.includes('src='));
    let regScript = scripts?.find(script => script.includes('<script>'));

    let srcFromScript = this.getSrcFromScript(srcScript);

    const srcScriptTag = document.createElement('script');

    regScript = regScript?.replace('<script>', '');
    regScript = regScript?.replace('</script>', '');

    if(srcFromScript) {
      srcScriptTag.setAttribute('src', srcFromScript);
      document.head.appendChild(srcScriptTag);
      setTimeout(() => {
        eval(regScript);
      },2000)
    }
    const div = document.createElement('div');
    div.innerHTML = this.embedCode;
    this.template.nativeElement.appendChild(div);
  }

}
